import React from 'react';
import { Chip } from '@mui/material';
import type { SupportTicketReceipt } from '../../types';

export const STATUS_LABELS = { open: 'Open', in_progress: 'In progress', resolved: 'Resolved' };
export const displayDate = (value: string) => Number.isNaN(Date.parse(value)) ? 'Date unavailable'
  : new Date(value).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });

export function TicketStatus({ status }: Pick<SupportTicketReceipt, 'status'>) {
  return <Chip size="small" variant="outlined" label={STATUS_LABELS[status] || status}
    color={status === 'resolved' ? 'success' : status === 'in_progress' ? 'info' : 'default'} />;
}
